import { render, staticRenderFns } from "./CollectItem.vue?vue&type=template&id=dbcf77b0&scoped=true&"
import script from "./CollectItem.vue?vue&type=script&lang=js&"
export * from "./CollectItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectItem.vue?vue&type=style&index=0&id=dbcf77b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcf77b0",
  null
  
)

export default component.exports